<template>
  <div class="happySpace">
    <div class="happySpace_top">
      <img
        class="happySpace_top_goback"
        src="@/assets/images/grow-club/back.png"
        @click="goback"
      />
      <img
        class="happySpace_top_right"
        src="@/assets/images/grow-club/emotion-people.png"
      />
    </div>
    <div class="happySpace_tab">
      <div class="happySpace_list">
        <div
          class="happySpace_item"
          :class="{ happySpace_item_active: item.active }"
          v-for="(item, index) in tabTitle"
          :key="index"
          @click="tabClick(index, item.name, item)"
        >
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
    <div v-if="!dataExit" class="happySpace_content">
      <div
        v-for="(item, index) in branchList"
        :key="index"
        class="happySpace_content_list"
        @click="goDetail(item)"
      >
        <p>{{ item.name }}</p>
      </div>
    </div>
    <div class="happySpaceDetail_box">
      <van-list
        ref="listContent"
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text=""
        @load="loadMore"
      >
        <div
          v-for="(item, index) in courseList"
          :key="index"
          class="happySpaceDetail_box_list"
          @click="goVideo(item)"
        >
          <img
            :src="item.coverMaterialUrl | addHost"
            alt="hi"
            class="happySpaceDetail_box_list_pic"
          />
          <!-- <div class="img_1" v-if="!item.coverMaterialUrl">
             <div class="img_1_1">
                  <img src="../../assets/images/parent-course/video-blank.png" class="happySpaceDetail_box_list_pic" alt='hi'/>
             </div>
          </div> -->
          <p class="happySpaceDetail_box_list_title">{{ item.title }}</p>
          <div v-if="item.tags" class="happySpaceDetail_box_list_title_list">
            <div
              v-for="(item1, index1) in item.tags.split(',').slice(0, 3)"
              :key="index1"
              :class="[
                index1 == 0 ? 'active1' : index1 == 1 ? 'active2' : 'active3',
                'happySpaceDetail_box_list_tag',
              ]"
            >
              {{ item1 }}
            </div>
          </div>
          <div class="happySpaceDetail_box_dec">
            <div class="happySpaceDetail_box_dec_circle"></div>
            <div class="happySpaceDetail_box_dec_title">{{ item.author }}</div>
          </div>
        </div>
      </van-list>
    </div>
    <div v-if="dataExit" class="nodata_part">
      <happy-data />
    </div>
  </div>
</template>
<script>
import {
  _getColumnLayer,
  _getColumnBranch,
  _getColumnContents,
} from "../../api/parent-course";
import { getRequest } from "../../assets/js/api";
import { horizontalScreen } from "../../assets/js/horizontal";
import happyData from "../../components/parent-course/happy-data.vue";
import BScroll from "better-scroll";

export default {
  components: { happyData },
  name: "happy-space",
  data() {
    return {
      courseList: [],
      finished: false, //加载状态
      loading: false,
      dataExit: false,
      tabValue: JSON.parse(sessionStorage.getItem("happyTabDeInfo"))
        ? JSON.parse(sessionStorage.getItem("happyTabDeInfo")).happyTabValue
        : 0,
      tabContentValue: 0, //tab栏目菜单切换值
      tabContentTitle: ["心理问题", "学习问题", "情绪问题"],
      //分级菜单列表的参数
      layerParams: {
        columnLayer: "一级栏目",
        page: 1, //当前页
        limit: 100, //每页多少条
        source: 2,
      },
      layerRecord: [], //一栏栏目所有的未经处理的数据
      tabTitle: [],
      branchList: [], //首页一级维度的数据
      firstAppearId: {}, //默认id发送当前请求,是个数据对象
      contentParams: {
        asc: false,
        currentPage: 0,
        // orderByField: "createTime",
        pageSize: 5,
        queryData: {
          columnId: "",
          contentType: "VIDEO",
          putaway: true,
          tag: "儿童",
        },
      },
      // 判断栏目下是否有视频文章或者层级关系
      existParams: {
        columnId: "",
        // code:'JZ'
      },
    };
  },
  created() {
    this.getColumnsLayer(this.layerParams);
    var app = document.getElementById("app");
    var touchstartY;
    app.addEventListener(
      "touchstart",
      function (event) {
        var events = event.touches[0] || event;
        touchstartY = events.clientY; //获取触摸目标在视口中的y坐标
      },
      false
    );
    app.addEventListener(
      "touchmove",
      function (event) {
        var events = event.touches[0] || event;
        //注意document.body.scrollTop始终为0
        var scrollTop =
          document.body.scrollTop || document.documentElement.scrollTop; //获取滚动部分的高度
        var clientHeight = document.documentElement.clientHeight; //获取手机屏幕高度（可视部分高度）
        var scrollHeight = document.body.scrollHeight; //所有内容的高度
        if (
          events.clientY > touchstartY &&
          scrollTop === 0 &&
          event.cancelable
        ) {
          event.preventDefault(); //禁止到顶下拉
        } else if (
          scrollTop + clientHeight > scrollHeight &&
          event.cancelable
        ) {
          event.preventDefault(); //禁止到底上拉
        }
      },
      false
    );
  },
  mounted() {
    horizontalScreen();
  },
  filters: {
    addHost: function (val) {
      let host = location.host;
      // return 'http://' + host + '/' + val
      //  return 'http://172.16.12.104:8999/' + val
      return val;
    },
  },
  methods: {
    loadMore() {
      let { contentParams } = this;
      contentParams.currentPage += 1;
      this.getColumnContents(contentParams);
    },
    tabClick(val, e, item) {
      if (item) {
        for (let i = 0; i < this.tabTitle.length; i++) {
          this.tabTitle[i].active = false;
        }
        item.active = true;
      }
      // this.$refs.tabref.resize()
      this.findId(val, e);
    },
    //点击返回按钮
    goback() {
      // 清楚开心空间中保存的tab信息
      sessionStorage.removeItem("happyTabDeInfo");
      this.$router.push("growGroup");
    },
    //跳转子集页面----tab页面
    goDetail(item) {
      this.$storage.setStore("happyInfo", item);
      //  保存当前栏目的id，为了播放视频中的下一条使用
      this.$storage.setStore("happyInfoTab", { id: item.id });
      // 点击去tab的时候，需要提前判断一下当前点击的事件中是否存在视频，如果有视频，就直接跳转至视频详情的页面
      // 如果是从一级栏目层级下方进入的，判断有无视频
      this.firstLayer = true;
      this.existParams.columnId = item.id;
      this.existContents(this.existParams, item);
      // this.$router.push({
      //     path:'/happySpaceTab',
      //     query:{
      //         title: item.title
      //     }
      // })
    },
    // 根据一级tab点击的文字获取对应的id
    findId(val, e) {
      let eNameObj = this.layerRecord.find((val) => val.name == e);
      if (eNameObj) {
        // this.getColumnBranch(eNameObj.id)
        // 更新接口，可以获取视频或者层级关系
        this.courseList = [];
        this.existParams.columnId = eNameObj.id + "";
        let tempOjb = {};
        tempOjb.happyTabValue = val;
        tempOjb.happyTabId = this.existParams.columnId;
        tempOjb.name = e;
        sessionStorage.setItem("happyTabDeInfo", JSON.stringify(tempOjb));
        //  保存当前栏目的id，为了播放视频中的下一条使用
        this.$storage.setStore("happyInfoTab", { id: eNameObj.id });
        this.existContents(this.existParams);
      }
    },
    goVideo(item) {
      this.$bus.$emit("fullFn", true);
      this.$storage.setStore("happySpaceVideo", item);
      this.$router.push({
        path: "/happySpaceVideo",
        query: {
          title: item.name,
          from: 1,
        },
      });
    },
    // 一级tab下，进入后判断当前栏目下面有没有视频数据
    // 判断当前栏目下的内容种类，是有文章/视频或者层级关系
    existContents(existParams, item) {
      this.contentParams.currentPage = 0;
      try {
        getRequest(
          "/api-content/column/exist/contents?columnId=" + existParams.columnId
        ).then(async (res) => {
          let { code, data, message } = res;
          if (res && code === 200) {
            // 如果data为true，有视频或者文章，fasle就没有视频或者文章
            // 有视频文章，就显示tab，并且可以进行切换
            if (data) {
              this.dataExit = true; //不能再显示栏目的层级
              this.branchList = []; //不能再显示栏目的层级
              this.contentParams.queryData.columnId = existParams.columnId;
              this.contentParams.currentPage += 1;
              await this.getColumnContents(this.contentParams);
              // 如果当前是从一级栏目层级下进入的，判断有无视频
              if (item && item.title) {
                this.$storage.setStore("happyInfoTab", item);
                this.$router.push({
                  path: "/happySpaceDetail",
                  query: {
                    // title: item.name
                    title: item.title,
                  },
                });
              }
            } else {
              // 没有视频和文章，就调用获取栏目层级的接口 cyccyc
              this.getColumnBranch(this.existParams.columnId);
              // 代表下一级没有视频资源，此时走tab页面
              if (item && item.title) {
                this.$router.push({
                  path: "/happySpaceTab",
                  query: {
                    title: item.title,
                  },
                });
              }
            }
          } else {
            Toast(message);
          }
        });
      } catch (error) {}
    },
    // 获取一级top tab切换标题
    //获取一级
    async getColumnsLayer(layerParams) {
      this.tabTitle = [];
      try {
        let res = await _getColumnLayer(layerParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          this.layerRecord = data.records;
          // 获取第一个id，初次显示使用
          this.firstAppearId = this.layerRecord[0].name;
          // 默认第一个数据，传递请求
          // if(this.tabValue === 0) {
          //     this.tabClick('',this.firstAppearId)
          // }
          // 获取到当前是否有点击保存过的tab信息
          let info = JSON.parse(sessionStorage.getItem("happyTabDeInfo"));
          // 如果没有，证明用户没有点击过，直接请求第一个
          if (info == null || info == undefined || !info.happyTabValue) {
            this.tabValue = 0;
            this.tabClick("", this.firstAppearId);
          } else {
            let tempV = info.happyTabValue;
            this.tabValue = tempV;
            let tempId = info.name;
            this.tabClick(tempV, tempId);
          }
          // 如果有，用户点击过，tab定位到用户点击的地方
          let tempArr = data.records;
          if (tempArr && tempArr.length > 0) {
            this.tabTitle = tempArr;
            for (let i = 0; i < this.tabTitle.length; i++) {
              this.tabTitle[i].active = false;
              this.tabTitle[this.tabValue].active = true;
            }
          } else {
            this.layerRecord = [];
            this.tabTitle = [];
          }
          // 列表滚动效果
          this.$nextTick(() => {
            let bs = new BScroll(".happySpace_tab", {
              pullUpLoad: true,
              // scrollbar: true,
              pullDownRefresh: true,
              scrollX: true,
              scrollY: false,
              bounce: false,
              click: true,
              quadrant: 2, // 父元素或者祖先元素旋转的角度为 (45, 135]，quadrant 建议为 2，尤其是 90 度，quadrant 必须为 2
            });
          });
        } else {
          this.layerRecord = [];
          this.tabTitle = [];
          Toast(message);
        }
      } catch (error) {}
    },
    // 根据id获取栏目下的内容
    async getColumnBranch(id) {
      try {
        getRequest(`/api-content/column/branches/` + id + "?code=ET").then(
          (res) => {
            let { code, message, data } = res;
            if (res && code === 200) {
              if (data && data.length > 0) {
                //cyccyc
                this.dataExit = false;
                this.branchList = data;
              } else {
                // 没数据，缺省图
                this.dataExit = true;
                this.branchList = [];
              }
            } else {
              this.branchList = [];
              this.dataExit = true;
              // 没数据，缺省图
              Toast(message);
            }
          }
        );
      } catch (error) {}
    },
    // 根据id获取栏目下的视频
    async getColumnContents(contentParams) {
      this.courseList = [];
      try {
        let res = await _getColumnContents(contentParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          //加载状态结束
          this.loading = false;
          // 合并第一次和第N次请求的书
          this.courseList = this.courseList.concat(data.records);
          //当数据全部加载完成
          if (data.records.length == 0) {
            this.finished = true;
          }
          // 列表滚动效果
          this.$nextTick(() => {
            let bs = new BScroll(".happySpaceDetail_box", {
              pullUpLoad: true,
              // scrollbar: true,
              pullDownRefresh: true,
              scrollX: true,
              scrollY: false,
              bounce: false,
              click: true,
              quadrant: 2, // 父元素或者祖先元素旋转的角度为 (45, 135]，quadrant 建议为 2，尤其是 90 度，quadrant 必须为 2
            });
          });
        } else {
          this.courseList = [];
          this.loading = false;
          Toast(message);
        }
      } catch (error) {}
    },
  },
};
</script>
<style lang="scss" scoped>
.happySpace {
  width: 100%;
  height: 100%;
  background: url(./../../assets/images/grow-club/space-bg.png);
  background-size: cover;

  .happySpace_top {
    display: flex;
    justify-content: space-between;

    .happySpace_top_goback {
      width: 29px;
      height: 29px;
      margin: 15px 0 0 15px;
    }

    .happySpace_top_right {
      width: 123px;
      height: 53px;
      margin: 10px 20px 0 0;
    }
  }

  .happySpace_tab {
    margin-top: 15px;
    width: auto;
    display: flex;
    overflow-x: scroll;

    .happySpace_list {
      background: none;
      display: flex;
      align-items: center;
      padding-right: 10px;
      .happySpace_item {
        position: relative;
        width: auto;
        height: 36px;
        line-height: 36px;
        border-radius: 8px;
        background-color: rgba($color: #faf4dc, $alpha: 0.3);
        box-shadow: 0px 0px 2px 2px #f2f2f2 inset;
        border-radius: 8px;
        margin-left: 15px;
        padding: 0 20px;
        &::before {
          position: absolute;
          left: 3px;
          top: 3px;
          content: "";
          display: block;
          background: url("../../assets/images/parent-course/top.png") no-repeat;
          width: 10px;
          height: 7px;
          background-size: cover;
          z-index: 9999999;
        }

        &::after {
          position: absolute;
          bottom: 3px;
          right: 3px;
          content: "";
          display: block;
          background: url("../../assets/images/parent-course/bot_p.png")
            no-repeat;
          width: 10px;
          height: 7px;
          background-size: cover;
        }
        p {
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          white-space: nowrap;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #fe8a23;
          z-index: 1;
        }
        &.happySpace_item_active {
          height: 38px;
          background: linear-gradient(180deg, #ffa07a 0%, #ff7a43 100%);
          box-shadow: none;
          text-align: center;
          width: auto;
          border-radius: 8px;
          color: #fff;
          &::before {
            position: absolute;
            left: 0px;
            top: 0px;
            content: "";
            display: block;
            background: url("../../assets/images/parent-course/act-top.png")
              no-repeat;
            width: 46px;
            height: 19px;
            background-size: cover;
            z-index: 0;
          }
          &::after {
            position: absolute;
            bottom: 0px;
            right: 0px;
            content: "";
            display: block;
            background: url("../../assets/images/parent-course/act-bot.png")
              no-repeat;
            width: 27px;
            height: 13px;
            background-size: cover;
            z-index: 0;
          }
          p {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #fff;
          }
        }
      }
    }
  }

  .nodata_part {
    margin-top: -30px;
  }

  .happySpace_content {
    margin-top: 18px;
    // padding-right: 23px;
    display: flex;
    width: 100%;
    overflow-x: scroll;

    .happySpace_content_list {
      margin-left: 30px;
      width: 210px;
      height: 127px;
      background: url(./../../assets/images/grow-club/space-box.png);
      background-size: cover;
      display: flex;
      align-items: center;

      p {
        width: 90px;
        margin-left: 97px;
        margin-right: 20px;
        text-align: left;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #d55514;
      }
    }
  }

  .happySpaceDetail_box {
    // border: 1px solid red;
    display: flex;
    width: auto;
    overflow-x: scroll;
    // margin-top: 15px;
    // margin-left: -50px;
    .van-list {
      display: flex;
    }

    .happySpaceDetail_box_list {
      transform: scale(0.9);
      width: 208px;
      height: 240px;
      background: url(./../../assets/images/grow-club/meng.png) no-repeat;
      background-size: 100% 100%;
      margin-left: 15px;

      .img_1 {
        // width: 208px;
        // height: 212px;
        background-color: #f8f7fa;
        // border: 1px solid red;
        .img_1_1 {
          // width: 60px;
          // height: 45px;
          // border: 1px solid red;
          img {
            width: 60px;
            height: 45px;
          }
        }
      }

      .happySpaceDetail_box_list_pic {
        width: 178px;
        height: 101px;
        margin-left: 15px;
        margin-right: 15px;
        margin-top: 15px;
      }

      .happySpaceDetail_box_list_title {
        font-size: 14px;
        height: 40px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        // text-align: center;
        padding-left: 16px;
        margin-top: 10px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .happySpaceDetail_box_list_title_list {
        display: flex;
        // justify-content: space-between;
        flex: 1;
        margin: 10px 15px;

        .happySpaceDetail_box_list_tag {
          margin-right: 5px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 17px;
          padding: 0 10px;
          border-radius: 11px;
          height: 22px;
          line-height: 22px;
          // &:first {
          //     margin-left: 0;
          // }
        }

        .active1 {
          background: rgba(255, 148, 134, 0.31);
          color: #f56444;
        }

        .active2 {
          background: rgba(255, 243, 235, 0.22);
          color: #ff8340;
        }

        .active3 {
          background: rgba(73, 204, 154, 0.1);
          color: #49cc9a;
        }
      }

      .happySpaceDetail_box_dec {
        display: flex;

        .happySpaceDetail_box_dec_circle {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #ffaa00;
          margin-left: 15px;
          margin-top: 6px;
        }

        .happySpaceDetail_box_dec_title {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          margin-left: 5px;
        }
      }
    }
  }

  .happySpace_content::-webkit-scrollbar {
    display: none;
  }
}

::-webkit-scrollbar {
  width: 0px;
}

::-webkit-scrollbar-track {
  background-color: none;
}

::-webkit-scrollbar-thumb {
  background-color: none;
}

::-webkit-scrollbar-thumb:hover {
  background-color: none;
}

::-webkit-scrollbar-thumb:active {
  background-color: none;
}
</style>
